
import { defineComponent, PropType } from 'vue'
import { AgentAction, AgentStatus } from '~/types/types'
import { getHumanizedTimeFromNow } from '~/utils/date'

export default defineComponent({
  name: 'AgentInfoSidebar',
  props: {
    agentActionsThisWeek: {
      type: Number,
      required: true
    },
    agentLatestAction: {
      type: Object as PropType<AgentAction> | null,
      default: null
    },
    agentStatus: {
      type: String as PropType<AgentStatus>,
      required: true
    },
    totalMemories: {
      type: Number,
      default: 0
    },
    canManageAgents: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    AgentStatus() {
      return AgentStatus
    },
    statusInfo() {
      switch (this.agentStatus) {
        case AgentStatus.Enabled:
          return {
            icon: 'circle-solid',
            color: 'juniper',
            label: 'Online'
          }
        case AgentStatus.Paused:
          return {
            icon: 'pause-circle',
            color: 'amber',
            label: 'Paused'
          }
      }
      return {
        icon: 'stop-circle',
        color: 'cherry',
        label: 'Offline'
      }
    },
    selectedStatus: {
      get() {
        return this.agentStatus as AgentStatus
      },
      set(status: AgentStatus) {
        this.$emit('update:status', status)
      }
    },
    getHumanizedTimeFromNow() {
      return getHumanizedTimeFromNow
    }
  },
  methods: {
    updateStatus(newStatus: AgentStatus) {
      this.selectedStatus = newStatus
    }
  }
})
